import React from "react";
import { AGILYSYS_LOGO_URL } from "../../constants/branding";
import "../styles/preloader.css";

export type PreloaderProps = {
  preloaderCheck?: boolean;
};

export const PreLoader: React.FC<PreloaderProps> = ({
  preloaderCheck = true,
}) => {
  if (!preloaderCheck) {
    return null;
  }

  return (
    <div
      className="agilysys-preloader"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="agilysys-preloader__logo-wrap">
        <img
          className="agilysys-preloader__logo"
          src={AGILYSYS_LOGO_URL}
          alt="Agilysys"
        />
      </div>
    </div>
  );
};
